'use strict';

var directdebit = angular.module('gymsystem.directdebit', []);

directdebit.controller('DirectDebitAddModalCtrl', ['$rootScope', '$scope', 'customer', '$controller', '$filter', 'banks', 'server', 'eventlog', 'Link', 'util', 'alertProvider', 'live', function($rootScope, $scope, customer, $controller, $filter, banks, server, eventlog, Link, util, alertProvider, live) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.item = customer;
    $scope.customer = customer;
    $scope.postUrl = '/api/directdebit/consent/add';
    $scope.callCloseOnSuccess = true;
    //$scope.data = { ignoreError: false };

    $scope.titleSuffix = function() {
        return $filter('translate')('consent for') + ' ' + customer.name;
    };

    var getClearingNumber = function() {
        return _.findWhere($scope.fields, {name: 'clearingNumber'}).value;
    };

    var getAccountNumber = function() {
        return _.findWhere($scope.fields, {name: 'account'}).value;
    };

    $scope.getSubmitItem = function() {
        return {id: $scope.customer.id,
                account: getAccountNumber(),
                clearingNumber: getClearingNumber(),
                personalCodeNumber: _.findWhere($scope.fields, {name: 'personalCodeNumber'}).value,
                changePending:_.findWhere($scope.fields, {name: 'changePending'}).value,
                legal_entity_id: $rootScope.selectedSite.legal_entity_id
            };
    };

    $scope.underage = function() {
        var pc = _.findWhere($scope.fields, {name: 'personalCodeNumber'});
        var item = { personalCodeNumber: pc.value };
        if (!customer.company && $rootScope.getAgeFromPersonalCodeNumber(item) < 18) {
            return true;
        }
    };

    var clearingNumberChange = function() {
        var clearingNumber = getClearingNumber();
        if (clearingNumber) {
            clearingNumber = String(clearingNumber).substring(0,4);
            $scope.bank = banks.getBank(clearingNumber);
        } else {
            $scope.bank = undefined;
        }

        _.findWhere($scope.fields, {name: 'bank'}).value = $scope.bank ? $scope.bank.name : '';
    };

    $scope.openLogs = function() {
        eventlog.openDialog({
            filter: new Link('user', Number(customer.id)),
            event: 'consent',
            noPeriod: true,
            hideFilter: true
        });
    };

    $scope.successTitle = 'Consent added';
    $scope.failedTitle = 'Failed to add consent';

    $scope.fields = [
        {name: 'clearingNumber', title: 'Clearing number', required: true, type: 'clearingNumber', max: 99999, change: clearingNumberChange },
        {name: 'bank', title: 'Bank', required: false, type: 'label' },
        {hint: 'BANK_ACCOUNT_HINT', hintLink: 'https://zoezi.atlassian.net/servicedesk/customer/portal/3/article/86999041', hintLinkText: 'BANK_ACCOUNT_HINT_LINK'},
        {name: 'account', title: 'Bank account number', required: true, type: 'bankAccountNumber2', getClearingNumber: getClearingNumber }
    ];

    if (customer.company) {
        $scope.fields.push( {name: 'personalCodeNumber', title: 'Corporate identity', required: true, type: 'corporateIdentity', original: $scope.customer.personalCodeNumber });
    } else {
        $scope.fields.push( {name: 'personalCodeNumber', title: 'Personal code number', required: true, type: 'personalCodeNumber', ptype: 'member', original: $scope.customer.personalCodeNumber });
    }

    $scope.fields.push( {name: 'changePending', title: 'Change pending payments', type: 'checkbox', value: true} );

    var pc = _.findWhere($scope.fields, {name: 'personalCodeNumber'});
    pc.value = $rootScope.formatPersonalCodeNumber($scope.customer.personalCodeNumber);
    if ($scope.customer.personalCodeNumber) {
        pc.readonly = true;
    }


    // debug code
    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var items = $scope.getSubmitItem();
        server.post($scope.postUrl, items, null, $scope.successTitle || 'Item added', $scope.failedTitle || 'Failed to add item', $scope.itemTitle).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                if (!$scope.customer.personalCodeNumber) {
                    $scope.customer.personalCodeNumber = items.personalCodeNumber;
                    server.post('/api/member/change', {id:$scope.customer.id, personalCodeNumber:items.personalCodeNumber}, null, null, null);
                }
                $scope.resetForm($scope);
                $scope.possiblyClose(result.data);
            } else {
                var data = {
                    submitted: items,
                    input: [],
                    fields: []
                };

                $scope.fields.forEach(function(field, i) {
                    data.fields.push({
                        index: i,
                        name: field.name,
                        value: field.value
                    });
                });

                document.querySelectorAll('[name~=addform]').forEach(function(form) {
                    form.querySelectorAll('input').forEach(function(e, i) {
                        data.input.push({
                            index: i,
                            name: e.name,
                            value: e.value
                        });
                    });
                });

                $.ajax({
                    url: '/api/admin/log/write',
                    headers: {
                        'Content-Type': 'application/json',
                        'encoder': 'post2'
                    },
                    method: 'POST',
                    dataType: 'json',
                    data: JSON.stringify({data: data})
                });


            }
        });
    };
    //

}]);

directdebit.controller('DirectDebitChangeModalCtrl', ['$rootScope', '$scope', 'customer', '$controller', '$filter', 'confirm', 'server', 'eventlog', 'Link', 'consent', function($rootScope, $scope, customer, $controller, $filter, confirm, server, eventlog, Link, consent) {

    $scope.customer = customer;
    $scope.postUrl = '/api/directdebit/consent/remove';

    $scope.payerNumber = consent.payer_number;

    $scope.titleSuffix = function() {
        return $filter('translate')('consent for') + ' ' + customer.name;
    };

    $scope.remove = function() {
        confirm.show('Are you sure you want to void the direct debit consent?', {ladda: true}).then(function(resolve) {
            server.post($scope.postUrl, null, {id: $scope.customer.id, legal_entity_id: $rootScope.selectedSite.legal_entity_id}, 'Consent cancelled', 'Failed to void consent').then(function() {
                resolve();
                $scope.$dismiss();
            });
        });
    };

    $scope.simulateFail = function() {
        server.post('/api/admin/test', {operation: 'servicebureau_consent_fail', data: { user_id: customer.id, legal_entity_id: $rootScope.selectedSite.legal_entity_id }}, null, 'Ok', 'Fail');
    };

    $scope.openLogs = function() {
        eventlog.openDialog({
            filter: new Link('user', Number(customer.id)),
            event: 'consent',
            noPeriod: true,
            hideFilter: true
        });
    };
}]);

directdebit.controller('DirectDebitCreateCtrl', ['$rootScope', '$scope', '$http', '$filter', '$modal', 'server', 'util', 'confirm', '$location', function($rootScope, $scope, $http, $filter, $modal, server, util, confirm, $location) {
    $scope.pendingPayments = [];
    $scope.pendingNewConsents = [];
    $scope.pendingCancelledConsents = [];
    $scope.isGettingPending = false;

    $scope.getNextSendDate = function() {
        var when = new Date();
        when.setMonth(when.getMonth() + 1);
        when.setDate(0);

        return when;
    };

    $scope.getNumberOfPayments = function() {
        return $scope.pendingPaymentsConfig.control?.getNumberOfItems() || 0;
    };

    $scope.getPaymentsButtonTitle = function() {
        var count = $scope.getNumberOfPayments();
        var what = $filter('translate')(count == 1 ? 'payment' : 'payments');

        return $filter('translate')('Create file with {0} {1}').format(count, what);
    };

    $scope.getNumberOfConsents = function() {
        var count = 0;
        if ($scope.pendingNewConsents) {
            count += $scope.pendingNewConsents.length;
        }
        if ($scope.pendingChangedPayerNumberConsents) {
            count += $scope.pendingChangedPayerNumberConsents.length;
        }
        if ($scope.pendingCancelledConsents) {
            count += $scope.pendingCancelledConsents.length;
        }

        return count;
    };

    $scope.getConsentsButtonTitle = function() {
        var count = $scope.getNumberOfConsents();
        var what = $filter('translate')(count == 1 ? 'consent' : 'consents');

        return $filter('translate')('Create file with {0} {1}').format(count, what);
    };

    var getPending = function() {
        var date = _.findWhere($scope.fields, {name: 'toDate'}).value;
        if (!date || date.getFullYear() < 2015) {
            return;
        }
        $scope.isGettingPending = true;
        const args = {
            toDate: date.yyyymmdd(),
            legal_entity_id: $rootScope.selectedSite.legal_entity_id
        };
        server.get('/api/directdebit/pending/get', args).then(function(pending) {
            $rootScope.waitFor(['members', 'staffs', 'trainingcardtypes', 'sites']).then(function() {
                $scope.pendingNewConsents = [];
                $scope.pendingChangedPayerNumberConsents = [];
                $scope.pendingCancelledConsents = [];

                angular.forEach(pending.payments, function(payment) {
                    $rootScope.transformPayment(payment);
                });
                $scope.pendingPayments = $scope.bundleTogether(pending.payments, true);
                $scope.broadcastChangeEvent('PendingPayments', $scope.pendingPayments);
                $scope.broadcastChangeEvent('ConsentMissing', $scope.pendingPayments);

                var added = [];
                var removed = [];
                var changedPayerNumber = [];

                // Invent an id to get rowClick working
                var id = 1;
                angular.forEach(pending.consents, function(consent) {
                    consent.id = id;
                    consent.user = $rootScope.getPointerById(consent.user_id, $rootScope.users);
                    consent.staff = $rootScope.getPointerById(consent.staff_id, $rootScope.staffs);
                    consent.created = Date.newFull(consent.created);
                    var arrays = {'add': added, 'remove': removed, 'changepay': changedPayerNumber, 'change': added};
                    arrays[consent.change].push(consent);
                    id += 1;
                });

                Array.prototype.push.apply($scope.pendingNewConsents, added);
                Array.prototype.push.apply($scope.pendingCancelledConsents, removed);
                Array.prototype.push.apply($scope.pendingChangedPayerNumberConsents, changedPayerNumber);

                $scope.isGettingPending = false;
            });
        });
    };

    $scope.fields = [
        {name: 'toDate', title: 'Due date', required: true, type: 'date', value: $scope.getNextSendDate(), change: getPending }
    ];
    $scope.hideSubmitButton = true;
    $scope.noFormValidation = true;

    $scope.getImage = function(p) {
        return $rootScope.smallMemberImage(p.payer || p.user);
    };

    $scope.createFiles = function(consents) {
        $scope.isCreatingFiles = true;
        var date = _.findWhere($scope.fields, {name: 'toDate'}).value;
        const args = {
            toDate: date.yyyymmdd(),
            includePayments: !consents,
            includeConsents: consents,
            legal_entity_id: $rootScope.selectedSite.legal_entity_id
        };
        server.post('/api/directdebit/files/create', null, args, 'Direct debit file created', 'Failed to create direct debit file').then(function(result) {
            $scope.isCreatingFiles = false;
            if (result.success) {
                getPending();

                angular.forEach(result.data, function(file) {
                    util.download(file.filename, file.data);
                });

                if (result.data.length > 1) {
                    $modal.open({
                        templateUrl: 'views/infomodal.html',
                        controller: 'ModalCtrl',
                        resolve: {
                            options: function() {
                                return {title: 'Information', content: 'Multiple files have been created. All files must be sent to the bank.' };
                            }
                        }
                    });
                }
            }
        });
    };

    $scope.areSettingsValid = function() {
        return $scope.settings && $scope.settings.customerNumber && $scope.settings.bankgiroNumber;
    };

    $scope.undoCancellation = function(consent) {
        confirm.show('Are you sure you want to undo the cancellation of the direct debit consent?', {ladda: true}).then(function(resolve) {
            server.post('/api/directdebit/consent/undoremove', null, {id: consent.user.id}, 'Consent cancellation undone', 'Failed to undo consent cancellation').then(resolve);
        });
    };

    $scope.pendingPaymentsControl = {};
    $scope.pendingPaymentsConfig = {
        getItems: function() {
            return $scope.pendingPayments;
        },
        itemFilter: function(p) {
            return p.payer.consent;
        },
        countSuffix: function() { return $scope.countSuffix($scope.pendingPaymentsConfig.control.getFilteredItems()); },
        rowClick: function(payment) { $scope.showPayments(payment, 'PendingPayments'); },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'totalamount', title: 'Amount', format: 'price' },
            {field: 'payer.name', title: 'Paid by' }
        ],
        buttons: [
            { title: 'Remove', visible: function(p) { return p.status == 'pending'; }, onClick: $scope.removeAll, buttonClass: 'btn-danger' }
        ]
    };

    $scope.addConsent = function(consent) {
        $modal.open({
            templateUrl: 'views/directdebitaddmodal.html',
            controller: 'DirectDebitAddModalCtrl',
            resolve: {
                customer: function() {
                    return consent.user;
                }
            }
        });
    };

    $scope.consentMissingControl = {};
    $scope.consentMissingConfig = {
        getItems: function() {
            return _.uniq($scope.pendingPayments, 'payer_id');
        },
        itemFilter: function(p) {
            if (!p.payer.consents) {
                return false; // Placeholder
            }
            return !p.payer.consents[$rootScope.selectedSite.legal_entity_id];
        },
        hideSearch: true,
        rowClick: function(consent) {
            $rootScope.gotoCustomer(consent.user);
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Paid by' }
        ],
        buttons: [
            { title: 'Add consent', onClick: $scope.addConsent, buttonClass: 'btn-success' }
        ]
    };

    var formatAccount = function(consent) {
        return consent.clearingNumber + '-' + consent.account;
    };

    $scope.pendingNewConsentsConfig = {
        getItems: function() {
            return $scope.pendingNewConsents;
        },
        showCount: function() {
            return true;
        },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            $rootScope.gotoCustomer(consent.user);
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'user.name', title: 'Name' },
            {field: 'user.personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'account', title: 'Bank account number', getValue: formatAccount },
            {field: 'created', title: 'Modification date', format: 'datetime' },
            {field: 'staff', title: 'Modified by', getValue: function(p) { return p.staff ? p.staff.firstname + ' ' + p.staff.lastname : $filter('translate')('Unknown'); } }
        ]
    };

    $scope.pendingChangedPayerNumberConsentsConfig = {
        getItems: function() {
            return $scope.pendingChangedPayerNumberConsents;
        },
        showCount: function() {
            return true;
        },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            $rootScope.gotoCustomer(consent.user);
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'user.name', title: 'Name' },
            {field: 'user.personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'oldPayerNumber', title: 'Old payer number' },
            {field: 'created', title: 'Modification date', format: 'datetime' },
            {field: 'staff', title: 'Modified by', getValue: function(p) { return p.staff ? p.staff.firstname + ' ' + p.staff.lastname : $filter('translate')('Unknown'); } }
        ]
    };

    $scope.pendingCancelledConsentsConfig = {
        getItems: function() {
            return $scope.pendingCancelledConsents;
        },
        showCount: function() {
            return true;
        },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            $rootScope.gotoCustomer(consent.user);
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'user.name', title: 'Name' },
            {field: 'user.personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'created', title: 'Modification date', format: 'datetime' },
            {field: 'staff', title: 'Modified by', getValue: function(p) { return p.staff ? p.staff.firstname + ' ' + p.staff.lastname : $filter('translate')('Unknown'); } }
        ],
        buttons: [
            { title: 'Undo', buttonClass: 'btn-danger', onClick: $scope.undoCancellation }
        ]
    };

    server.get('/api/directdebit/settings/get', { legal_entity_id: $rootScope.selectedSite.legal_entity_id }).then(function(data) {
        $scope.settings = data;
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'payment' || message.type == 'member' || message.type == 'user') {
            getPending();
        }
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
    });

    if ($location.path().indexOf('/payment/directdebit/consents') != -1) {
        var twoYearsFromNow = new Date();
        twoYearsFromNow.setFullYear(twoYearsFromNow.getFullYear() + 2);
        _.findWhere($scope.fields, {
            name: 'toDate'
        }).value = twoYearsFromNow;
    }

    getPending();
}]);

directdebit.controller('DirectDebitConsentsCtrl', ['$rootScope', '$scope', '$modal', function($rootScope, $scope, $modal) {
    $scope.addConsent = function(payer) {
        $modal.open({
            templateUrl: 'views/directdebitaddmodal.html',
            controller: 'DirectDebitAddModalCtrl',
            resolve: {
                customer: function() {
                    return payer;
                }
            }
        });
    };

    $scope.consentMissingConfig = {
        api: {
            url: '/api/directdebit/missing/consents/get',
            args: {
                legal_entity_id: $rootScope.selectedSite.legal_entity_id
            },
            triggers: [{type: 'payment'}, {type: 'user'}],
            transform: function(payer_id, index, array) {
                array[index] = $rootScope.getMember(payer_id);
            }
        },
        countSuffixList: ['customer', 'customers'],
        rowClick: $rootScope.gotoCustomer,
        columns: [
            {field: 'image', title: '', src: $rootScope.smallMemberImage },
            {field: 'name', title: 'Paid by' }
        ],
        buttons: [
            { title: 'Add consent', onClick: $scope.addConsent, buttonClass: 'btn-success' }
        ]
    };
}]);

directdebit.controller('DirectDebitFakeCtrl', ['$rootScope', '$scope', 'server', 'util', function($rootScope, $scope, server, util) {
    $scope.fakeFileContent = "";
    $scope.fakeConsentFileContent = "";
    $scope.fakeFileRandomContent = "";

    var getFakeFile = function() {
        $rootScope.waitFor(['members']).then(function() {
            const args = {
                legal_entity_id: $rootScope.selectedSite.legal_entity_id
            };
            server.get('/api/directdebit/settings/get', args).then(function(data) {
                var settings = data;

                server.get('/api/directdebit/sent/get', args).then(function(data) {

                    var getDate = function(d) {
                        return d.yyyymmddCompact();
                    };
                    var getShortDate = function(d) {
                        return d.yyyymmddCompact().substring(2);
                    };
                    var blanks = function(num, c) {
                        if (c == undefined) {
                            c = ' ';
                        }
                        return new Array(num+1).join(c);
                    };
                    var blankify = function(x, num) {
                        x = String(x);
                        return blanks(num - x.length) + x;
                    };
                    var nullify = function(x, num) {
                        x = String(x);
                        return blanks(num - x.length, '0') + x;
                    };
                    var getAmount = function(x, num) {
                        x = Number(x) + '00';
                        return nullify(x, num);
                    };

                    var lines = [];
                    lines.push('01' +  getDate(new Date()) + 'AUTOGIRO9900' + blanks(40) + nullify(settings.customerNumber, 6) + nullify(settings.bankgiroNumber, 10) + blanks(2));

                    var getBundles = function(payments) {
                        var bundles = {};
                        angular.forEach(payments, function(payment) {
                            if (!bundles[payment.bundle_id]) {
                                bundles[payment.bundle_id] = payment;
                            } else {
                                bundles[payment.bundle_id].amount = Number(bundles[payment.bundle_id].amount) + Number(payment.amount);
                            }
                        });
                        return _.values(bundles);
                    };

                    var bundles = getBundles(data.payments);
                    angular.forEach(bundles, function(payment) {
                        $rootScope.transformPayment(payment);

                        if (payment.payer) {
                            lines.push('82' + getDate(payment.date) + '0' + nullify('0',3) + blanks(1) + nullify(payment.payer.personalCodeNumber, 16) + getAmount(payment.amount, 12) + nullify('', 10) + blankify(payment.referenceNumber || payment.bundle_id, 16) + blanks(10) + blanks(1));
                        }
                    });

                    $scope.fakePaymentFileContent = lines.join('\r\n');

                    var paymentTypes = {'success': {code: ' ', count: 0}, 'nomoney': {code: '1', count: 0}, 'noautogiro': {code:'2', count: 0}, 'retry': {code:'9', count: 0}};
                    lines.splice(1, lines.length-1);
                    angular.forEach(bundles, function(payment) {
                        if (payment.payer) {
                            var typename;
                            if (!paymentTypes.success.count) {
                                typename = 'success';
                            } else if (!paymentTypes.nomoney) {
                                typename = 'nomoney';
                            } else {
                                typename = _.sample(['success', 'nomoney', 'noautogiro', 'retry']);
                            }

                            var type = paymentTypes[typename];
                            type.count++;
                            lines.push('82' + getDate(payment.date) + '0' + nullify('0',3) + blanks(1) + nullify(payment.payer.personalCodeNumber, 16) + getAmount(payment.amount, 12) + nullify('', 10) + blankify(payment.referenceNumber || payment.bundle_id, 16) + blanks(10) + type.code);
                        }
                    });
                    $scope.fakeFileRandomContent = lines.join('\r\n');

                    lines = [];
                    lines.push('01' +  getDate(new Date()) + '9900' + nullify(settings.bankgiroNumber, 10) + 'AG-MEDAVI' + blanks(47));
                    angular.forEach(data.consents, function(consent) {
                        var infocode = consent.change == 'remove' ? 3 : 4;
                        var commentcode = consent.change == 'remove' ? 33 : 32;
                        var clearingNumber = String(consent.clearingNumber).substring(0,4);
                        var account = clearingNumber + nullify(consent.account, 12);
                        lines.push('73' + nullify('', 10) + nullify(consent.user_id, 16) + (consent.account ? account : blanks(16)) + consent.personalCodeNumber + blanks(5) + nullify(infocode, 2) + nullify(commentcode, 2) + getDate(new Date()) + getShortDate(new Date()) + blanks(1));
                    });
                    $scope.fakeConsentFileContent = lines.join('\r\n');

                });
            });
        });
    };
    getFakeFile();

    $scope.downloadFake = function() {
        util.download('AutogiroFakeFile.txt', $scope.fakeFileRandomContent);
    };

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'payment' || message.type == 'member') {
            getFakeFile();
        }
    });


    $scope.$on('$destroy', function () {
        removeServerChange();
    });
}]);

directdebit.controller('SettingsDirectDebitCtrl', ['$rootScope', '$scope', '$controller', 'formatter', 'server', 'confirm', function($rootScope, $scope, $controller, formatter, server, confirm) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = `/api/directdebit/settings/get?legal_entity_id=${$rootScope.selectedSite.legal_entity_id}`;
    $scope.postUrl = `/api/directdebit/settings/set?legal_entity_id=${$rootScope.selectedSite.legal_entity_id}`;

    $scope.getNiceBankgiroNumber = function() {
        return formatter.format('bankgiroNumber', $scope.item.bankgiroNumber);
    };

    $scope.fields = [
        {name: 'customerNumber', title: 'BGC customer number', required: true, type: 'number', max: 999999},
        {name: 'bankgiroNumber', title: 'Bankgiro number', required: true, type: 'bankgiroNumber', getValue: function(f) { return $rootScope.normalizeBankgiroNumber(f.value); }, setValue: $scope.getNiceBankgiroNumber },
        {name: 'sendMail', title: 'Send direct debit invoice by e-mail to customer', type: 'checkbox' },
        {name: 'billingDate', title: 'Billing date', required: $rootScope.selectedSite.legal_entity_id == $rootScope.default_legal_entity_id, type: 'number', min: 1, max: 31, helpText: 'First billing date for direct debit. Additional billing attempts can be made after the specified date', placement: 'right', readonly: $rootScope.selectedSite.legal_entity_id != $rootScope.default_legal_entity_id },
        {hint: 'The date may be adjusted depending on month', visible: function() { return _.findWhere($scope.fields, {name: 'billingDate'}).value > 28; }},
        {name: 'minAmount', title: 'Minimum invoice amount', required: false, type: 'price', placeholder: 'No limit', helpText: 'Merges smaller purchases and sends payment when the specified amount is reached', placement: 'right' },
        {name: 'autosave_bankaccount', title: 'Auto save bank account', type: 'checkbox', visible: function() { return $rootScope.hasModule('Payment'); } },
        {hint: 'AUTOSAVE_INFO'}
    ];

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        if (item.billingDate != $rootScope.billingDay) {
            const args = {
                legal_entity_id: $rootScope.selectedSite.legal_entity_id
            };
            server.get('/api/economy/directdebit/pending/count', args).then(function(result) {
                if (result > 0) {
                    confirm.show('DDCHANGEDAY').then(function() {
                        item.changePending = true;
                        $scope.doSubmit(item);
                    }, function() {
                        $scope.doSubmit(item);
                    });
                } else {
                    $scope.doSubmit(item);
                }
            });
        } else {
            $scope.doSubmit(item);
        }
    };

    $scope.getSettings();
}]);

directdebit.controller('DirectDebitFilesCtrl', ['$rootScope', '$scope', 'server', '$filter', 'util', function($rootScope, $scope, server, $filter, util) {
    $scope.loadingStatus = {loading: true};

    $scope.download = function(file) {
        util.download(file.filename, file.data);
    };

    $scope.files = [];
    $scope.filesConfig = {
        getItems: function() { return $scope.files; },
        showCount: function() {
            return true;
        },
        countSuffixList: ['file', 'files'],
        columns: [
            {field: 'created', title: 'Date', format: 'date' },
            {field: 'filename', title: 'Filename' },
            {field: 'rows', title: 'Number of rows' },
            {field: 'staff', title: 'Created by', getValue: function(p) { return p.staff ? p.staff.name : $filter('translate')('Unknown'); } }
        ],
        orderColumn: '-created',
        buttons: [
            { title: 'Download', buttonClass: 'btn-success', onClick: $scope.download }
        ]
    };

    const args = {
        legal_entity_id: $rootScope.selectedSite.legal_entity_id
    };
    server.get('/api/directdebit/files/get', args).then(function(data) {
        $rootScope.waitFor(['staffs']).then(function() {
            angular.forEach(data, function(file) {
                file.staff = $rootScope.getPointerById(file.staff_id, $rootScope.staffs);
                file.created = Date.newFull(file.created);
                file.rows = file.data.split('\n').length - 1;
            });
            $scope.files = data;
            $scope.loadingStatus.loading = false;
        });
    });
}]);

directdebit.controller('DirectDebitRemoveAllConsentsCtrl', ['$scope', 'confirm', 'server', function($scope, confirm, server) {
    $scope.removeAllConsents = function() {
        confirm.show('Are you sure you want to remove all direct debit consents?', {ladda: true}).then(function(resolve) {
            server.post('/api/directdebit/consent/removeAll', null, null, 'Consents removed', 'Failed to remove consents').then(resolve);
        });
    };
}]);
